if(!customElements.get('cart-toggle')) {
  class CartToggle extends HTMLElement {
    static observedAttributes = ["count"];

    constructor() {
      super();

      this.elToggle = this.querySelector('a');
      this.elCount = this.querySelector('[data-count]');

      this.elToggle && this.elToggle.addEventListener('click', window.toggleCart);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      this.elCount.innerHTML = `(${newValue})`;
    }
  }

  customElements.define('cart-toggle', CartToggle);
}